// Where a signed-out visitor was heading — e.g. a vault's wall QR scanned on
// a phone with no session — so the SSO round trip can land them back there
// instead of on the dashboard. sessionStorage survives the provider redirect
// in the same tab and dies with it.
const KEY = "pip.postLoginPath";

// Landing on these after sign-in is the default anyway.
const NOT_WORTH_REMEMBERING = new Set(["/", "/dashboard", "/login"]);

// Only paths inside this app — never "//host" or a full URL.
const isAppPath = (path) =>
  typeof path === "string" && path.startsWith("/") && !path.startsWith("//");

export function rememberPostLoginPath(location) {
  if (!location || NOT_WORTH_REMEMBERING.has(location.pathname)) return;
  try {
    window.sessionStorage.setItem(KEY, `${location.pathname}${location.search || ""}`);
  } catch (_error) {
    // Storage blocked (private mode etc.) — they land on the dashboard.
  }
}

// Read without consuming — lets the login page say why sign-in is needed.
export function peekPostLoginPath() {
  try {
    const path = window.sessionStorage.getItem(KEY);
    return isAppPath(path) ? path : null;
  } catch (_error) {
    return null;
  }
}

export function takePostLoginPath() {
  try {
    const path = window.sessionStorage.getItem(KEY);
    window.sessionStorage.removeItem(KEY);
    return isAppPath(path) ? path : null;
  } catch (_error) {
    return null;
  }
}
